import { Box } from '@hivebrite/design-system/Box';
import { ButtonInLink } from '@hivebrite/design-system/ButtonInLink';
import { Dotdotdot } from '@hivebrite/design-system/Dotdotdot';
import {
  CATEGORIES,
  FontAwesomeIcon,
} from '@hivebrite/design-system/FontAwesomeIcon';

import { AIWrapper } from 'hb-react/shared/components/AIWrapper';

interface UserIntroductionProps {
  user: {
    introduction?: string;
  };
  userId: number;
  isOwnProfile: boolean;
}

export const UserIntroduction = ({
  user,
  userId,
  isOwnProfile,
}: UserIntroductionProps) => {
  if (!user.introduction && isOwnProfile) {
    return (
      <Box mt={2} dataTestId="user-snapshot-ai-introduction-container">
        <AIWrapper
          id="user-snapshot-ai-introduction"
          style={{ gap: 12 }}
          flexDirection="column"
          trigger
          shouldTriggerOnlyOncePerSession
        >
          <Box>
            {s__(
              'UserProfile|Share what drives you and what you bring to this community.',
            )}
          </Box>
          <Box>
            <ButtonInLink
              dataTestId="user-snapshot-ai-introduction-button"
              icon={() => (
                <FontAwesomeIcon
                  height="16px"
                  iconName="sparkles"
                  iconType={CATEGORIES.SOLID}
                />
              )}
              variant="inversed"
              linkProps={{
                to: Routes.user_path(userId),
              }}
              isFullWidth
            >
              {s__('UserProfile|Write my introduction with AI')}
            </ButtonInLink>
          </Box>
        </AIWrapper>
      </Box>
    );
  }

  return <Dotdotdot clamp={3}>{user.introduction}</Dotdotdot>;
};
